<template lang="pug">
div
  v-img(:src="logoSvg" width="140px")
  v-layout.text-xs-left.pa-2
    .subheading(v-if="subtitle")
      | {{ subtitle }}
      div
        a( v-if="readMoreLink" @click.native.stop :href="readMoreLink" target="_blank" ) Learn more about the integration here

  div(flat style="float: right;")
    v-btn(
      v-if="!active && !merchantId" 
      @click.native.stop 
      @click="buttonFunction(enrollmentLink)" 
      color="secondary"
      flat
      outline
    ) SIGN UP
</template>

<script>
  export default {
    name: 'lender-list-tile',
    props: {
      logo: String,
      logoSvg: String,
      title: String,
      subtitle: String,
      merchantId: String,
      readMoreLink: String,
      enrollmentLink: String,
      color: String,
      active: {
        type: Boolean,
        default: null,
      },
    },
    methods: {
      buttonFunction(enrollmentLink){
        window.open(enrollmentLink, '_blank').focus()
      },
    }
  }
</script>

<style lang="scss" scoped>
  @media (max-width: 375px) {
    .subheading {
      font-size: small !important;
    }
  }
 
</style>
